import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL } from '../../../config';
import { env } from '../../../env';
import { getAccessTokenCookie } from '../../../utils/sessionCookies';

const baseService = createApi({
  reducerPath: 'baseService',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    prepareHeaders: (headers, { getState }) => {
      const token = getAccessTokenCookie();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('X-Api-Key', env.REACT_APP_API_KEY);
      }
      return headers;
    },
  }),
  tagTypes: ['Messages'],
  endpoints: () => ({}),
});

export default baseService;
